import React from "react";

const ShortenStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.19922 6C1.78501 6 1.44922 6.33579 1.44922 6.75C1.44922 7.16421 1.78501 7.5 2.19922 7.5H13.7992C14.2134 7.5 14.5492 7.16421 14.5492 6.75C14.5492 6.33579 14.2134 6 13.7992 6H2.19922ZM2.19922 9C1.78501 9 1.44922 9.33579 1.44922 9.75C1.44922 10.1642 1.78501 10.5 2.19922 10.5H7.79922C8.21343 10.5 8.54922 10.1642 8.54922 9.75C8.54922 9.33579 8.21343 9 7.79922 9H2.19922Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ShortenStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;